<template>
    <v-container>
        <v-layout row wrap v-if="! confirmed">
            <v-flex xs12 s12 md12>
                <v-btn :href="BASE + 'order/' + order_id + '?download_token=' + download_token" target="_blank"><v-icon left>assignment</v-icon>Preview order confirmation</v-btn>

                <v-dialog v-model="dialog" persistent max-width="600px">
                    <v-btn slot="activator" color="primary" dark>Upload signed order confirmation</v-btn>
                    <v-card>
                        <v-card-title>
                            <span class="headline">Upload signed order confirmation</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm12 md12>
                                        <vue-dropzone ref="myVueDropzone2" id="dropzone2" :options="dropzoneOptions2" v-on:vdropzone-success="signed()"></vue-dropzone>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
                            <v-btn color="blue darken-1" flat @click="dialog = false">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-card>
                    <v-toolbar color="light-blue" dark>
                        <v-toolbar-title>Documents</v-toolbar-title>
                    </v-toolbar>

                    <v-list two-line subheader>
                        <v-list-tile
                                v-for="item in documents"
                                :key="item.file"
                                avatar
                                target="_blank"
                        >
                            <v-list-tile-avatar>
                                <v-icon>picture_as_pdf</v-icon>
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title>{{ item.file }}</v-list-tile-title>
                                <v-list-tile-sub-title>{{ item.created_at }}</v-list-tile-sub-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-btn icon ripple :href="API_BASE + 'orders/' + order_id + '/pdf/' + item.id + '?token=' + item.token + '&download_token=' + download_token" target="_blank">
                                    <v-icon color="primary">cloud_download</v-icon>
                                </v-btn>
                            </v-list-tile-action>
                            <v-list-tile-action>
                                <v-btn icon ripple @click="borrar(item.id)">
                                    <v-icon color="red">delete</v-icon>
                                </v-btn>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>
                </v-card>
            </v-flex>

            <v-flex xs12 s12 md12 class="mt-4">
                <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-success="getDocuments()"></vue-dropzone>
            </v-flex>
        </v-layout>

        <v-layout row v-if="confirmed">
            <v-flex xs12 class="text-xs-center">
                    <v-btn
                            dark
                            color="blue lighten-2"
                            :href="BASE + 'order/' + order_id + '/confirmation?download_token=' + download_token"
                            target="_blank"
                    >
                        Download order confirmation
                    </v-btn>
                <v-btn dark color="red" @click="unconfirm()">remove order confirmation</v-btn>
                <v-btn :href="BASE + 'order/' + order_id + '?download_token=' + download_token" target="_blank"><v-icon left>assignment</v-icon>Preview order confirmation</v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'

    import { API_BASE } from  '../../../../../src/config.js';
    import { BASE } from '../../../../../src/config.js'

    export default {
        props: ['order_id', 'confirmed'],
        data: function () {
            return {
                dialog: false,
                dropzoneOptions: {
                    url: API_BASE + 'orders/' + this.order_id + '/pdf',
                    thumbnailWidth: 150,
                    maxFilesize: 500,
                    headers: { 'Authorization' : localStorage.getItem('token'),
                        'Autrollization' : localStorage.getItem('token'),
                        'Authorization-temp' : localStorage.getItem('token')
                    },
                    addRemoveLinks: true,
                },
                dropzoneOptions2: {
                    url: API_BASE + 'orders/' + this.order_id + '/signed',
                    thumbnailWidth: 150,
                    maxFilesize: 500,
                    headers: { 'Authorization' : localStorage.getItem('token'),
                        'Autrollization' : localStorage.getItem('token'),
                        'Authorization-temp' : localStorage.getItem('token')
                    },
                    addRemoveLinks: true,
                    maxFiles: 1
                },
                documents: [],
                API_BASE: API_BASE,
                BASE: BASE,
                download_token: null
            }
        },
        components: {
            vueDropzone: vue2Dropzone
        },
        created () {
            this.checkUser();
            this.getDocuments();
        },
        methods: {
            checkUser() {
                this.$store.dispatch('checkAccessToken').then((res) => {
                    this.download_token = this.$store.getters.getUser.download_token;
                }).catch((error) => {

                });
            },
            signed () {
                this.dialog = false;
                this.$emit('signed');
            },
            unconfirm () {
                this.$store.dispatch('unconfirmOrder', {
                    order_id: this.order_id
                }).then((res) => {
                    this.$emit('unconfirmed');
                }).catch((error) => {

                });
            },
            borrar (documento_id) {
                this.$store.dispatch('deleteDocumentConfirmation', {
                    order_id: this.order_id,
                    documento_id: documento_id
                }).then((res) => {
                    this.getDocuments();
                }).catch((error) => {

                });
            },
            getDocuments () {
                this.$store.dispatch('getOrderDocumentsConfirmation', {
                    order_id: this.order_id
                }).then((res) => {
                    this.documents = res.data;
                }).catch((error) => {

                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/orders/views/ConfirmationComponent.vue